import { ProjectMilestoneStatus, PROJECT_STATUS } from "@/enums";
import { IProject } from "@/interfaces";

import { flattenProjectScheduleMilestones } from "../../../helper/flattenProjectScheduleMilestones";

export const getCanChangeToCompleteFromActive = (
  project: IProject
): boolean => {
  let canChangeToComplete = true;

  if (project.status === PROJECT_STATUS.project.active.id) {
    const flattenedMilestones = flattenProjectScheduleMilestones(project);

    if (flattenedMilestones) {
      const hasInProgress = flattenedMilestones.find(
        (flatMilestone) =>
          flatMilestone.status === ProjectMilestoneStatus.InApproval
      );
      if (hasInProgress) {
        canChangeToComplete = false;
      }
    }
  }

  return canChangeToComplete;
};
